<template>
    <section class="service-package" id="home-service">
        <div class="container">
            <div class="row">
                <div class="comparison-banner col-xs-12 p-a-0 m-y">
                    <div class="comparison-details col-xs-12 col-md-4 text-center m-y">
                        <div class="img-container comparison-icons">
                            <img :src="firstComparisonImage" alt="" class="m-auto">
                        </div>
                        <div class="content">
                            <div class="text text-white">
                                <h3>{{ landingPageSections[3].body | stripTags }}</h3>
                            </div>
                        </div>
                    </div>
                    <div class="comparison-details col-xs-12 col-md-4 text-center m-y">
                        <div class="img-container comparison-icons">
                            <img src="images/icons/performance.svg" alt="" class="m-auto">
                        </div>
                        <div class="content">
                            <div class="text text-white">
                                <h3>{{ landingPageSections[4].body | stripTags }}</h3>
                            </div>
                        </div>
                    </div>
                    <div class="comparison-details col-xs-12 col-md-4 text-center m-y">
                        <div class="img-container comparison-icons">
                            <img src="images/icons/2-year-system-warranty.svg" alt="" class="m-auto">
                        </div>
                        <div class="content">
                            <div class="text text-white">
                                <h2>{{ landingPageSections[7].body | stripTags }}</h2>
                            </div>
                        </div>
                    </div>
                    <div class="comparison-details col-xs-12 col-md-4 text-center m-y">
                        <div class="img-container comparison-icons">
                            <img src="images/icons/2year-ico.png" alt="" class="m-auto">
                        </div>
                        <div class="content">
                            <div class="text text-white">
                                <h3>{{ landingPageSections[5].body | stripTags }}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: 'ComparisonBanner',
    props: {
        which: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            slickConfig: {
                dots: false,
                arrows: false,
                infinite: true,
                autoplay: true,
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 1,
                autoplaySpeed: 4000,
                responsive: [
                    {
                        breakpoint: 1366,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    },
                    {
                        breakpoint: 770,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            },
        }
    },
    computed: {
        ...mapState({
            landingPageSections: state => state.StarterPc.pageData.landing_page_sections
        }),
        firstComparisonImage() {
            return this.which == "creator-pc" ? "images/icons/pursue-passion.svg" : "images/icons/joystick.svg";
        }
    },
    mounted() {
        this.initializeSlickGallery();
    },
    methods: {
        initializeSlickGallery() {
            $(".comparison-banner").slick(
                Object.assign(this.slickConfig, {
                    dots: true,
                })
            );
        },
    }
}
</script>

<style lang="scss">
.comparison-banner {
    .slick-track {
        margin: 0 auto;
    }

    .comparison-details {
        width: 260px;

        .comparison-icons {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 13px;

            img {
                height: 64px;
                width: 60px;
            }
        }

        h2, h3 {
            line-height: 21px;
            font-size: 16px;
            margin: 0 0 10px;
        }
    }
}

#home-service {
    @media (min-width: 320px) and (max-width: 580px) {
        padding: 0;
    }
}
</style>
